(function () {
  function initSwatches(root) {
    root = root || document;

    root.querySelectorAll('[id^="card-"]').forEach(function (card) {
      var productId = card.id.replace('card-', '');
      var LOG = '[Swatch:' + productId + ']';

      if (card.dataset.swatchInit === '1') return;
      card.dataset.swatchInit = '1';

      var variantDataEl = document.getElementById('variant-data-' + productId);
      if (!variantDataEl) {
        console.warn(LOG, 'No variant data JSON found');
        return;
      }

      var image = card.querySelector('.media img');
      if (!image) {
        console.warn(LOG, 'No .media img found');
        return;
      }

      var variantImages;
      try {
        variantImages = JSON.parse(variantDataEl.textContent);
      } catch (e) {
        console.error(LOG, 'JSON parse failed:', e);
        return;
      }

      var checkedInput = card.querySelector(
        '.product-form__swatch input[data-product-id="' + productId + '"]:checked'
      );

      if (checkedInput) {
        var initId = checkedInput.dataset.variantId;
        if (initId && window.cardSetVariant) window.cardSetVariant(productId, initId);
        if (initId && variantImages[initId]) {
          image.src = variantImages[initId];
          image.srcset = '';
        }
      }

      card.querySelectorAll(
        '.product-form__swatch input[data-product-id="' + productId + '"]'
      ).forEach(function (input) {
        var fresh = input.cloneNode(true);
        input.parentNode.replaceChild(fresh, input);

        fresh.addEventListener('change', function () {
          var variantId = this.dataset.variantId;
          if (variantId && window.cardSetVariant) window.cardSetVariant(productId, variantId);
          if (!variantId || !variantImages[variantId]) return;

          image.style.transition = 'opacity 0.3s ease';
          image.style.opacity = '0';
          setTimeout(function () {
            image.src = variantImages[variantId];
            image.srcset = '';
            image.onload = function () { image.style.opacity = '1'; };
            setTimeout(function () { image.style.opacity = '1'; }, 300);
          }, 150);
        });
      });

      console.log(LOG, 'Init complete');
    });
  }

  function attachGridObserver(grid) {
    if (!grid || grid.dataset.swatchObserver === '1') return;
    grid.dataset.swatchObserver = '1';
    new MutationObserver(function () {
      initSwatches(grid);
    }).observe(grid, { childList: true, subtree: true });
  }

  function setup() {
    // Cards already in DOM (featured collection etc.)
    initSwatches(document);

    // product-recommendations (AJAX fetch → renderContents)
    document.querySelectorAll('product-recommendations').forEach(function (el) {
      attachGridObserver(el);
    });

    // recently-viewed grid (innerHTML injection)
    attachGridObserver(document.getElementById('recently-viewed-grid'));
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  // Safety net: if recently-viewed-grid doesn't exist yet at setup time,
  // watch for it to appear then attach its observer
  var bodyObserver = new MutationObserver(function () {
    var rvGrid = document.getElementById('recently-viewed-grid');
    if (rvGrid && rvGrid.dataset.swatchObserver !== '1') {
      attachGridObserver(rvGrid);
      // also run once immediately in case cards were already added
      initSwatches(rvGrid);
    }
  });
  bodyObserver.observe(document.body, { childList: true, subtree: false });

})();